import { createComponentState } from '@/state';

/** Sorting state for the clients table, managed as a Zustand store. */
export type ClientsTableSortingState = {
  sorting: {
    column: string | undefined;
    direction: 'asc' | 'desc' | undefined;
  };
};

const useClientsTableState = createComponentState<ClientsTableSortingState>({
  sorting: { column: undefined, direction: undefined },
});

export default useClientsTableState;
